import { gql } from "@apollo/client";

const query = gql`
  query TalentFindOne(
    $filterListing: FilterFindOneListingInput!,
    $filterTalent: FilterFindOneTalentInput,
    $filterDistance: FilterFindOneTalentListingDistanceInput,
  ) {
    listing: listingFindOne(
      filter: $filterListing
    ) {
      _id
      listingId
      createdDate
      name
      details
    }
    talentFindOne(filter: $filterTalent) {
      linkedinId
      details
      linkedinProfile {
        linkedinId
        data
        linkedinCompanies {
          linkedinId
          data
        }
      }
      listingId
      applicationId
      candidateId
      listing {
        name
      }
    }
    talentListingDistanceOne(filter: $filterDistance) {
      listingId
      context
      name
      email
      linkedinId
      details
      summary
      priority
    }
  }
`;

export default {
  query,
};
